import P2Medium from 'components/typography/P2Medium';
import { RevisionRow } from 'components/tables/data/revision/types';

/**
 * Column for the organization name.
 */
export default function OrganizationNameColumn({ data: { organization } }: { data: RevisionRow }) {
  return <P2Medium color="gray.8">{organization.organizationName}</P2Medium>;
}
